import PropTypes from "prop-types";
import { Button } from "antd";
import { useApplicantTrackingById } from "../../../app/hooks/useApplicantTracking";
import { observer } from "mobx-react-lite";

const ResumeDatabaseModal = ({ applicants, currentIndex, onNext, onPrevious }) => {
  const currentApplicant = applicants?.[currentIndex];
  const { data: selectedApplicant } = useApplicantTrackingById(currentApplicant?.id, { enabled: !!currentApplicant?.id });
  const resumeUrl = selectedApplicant?.applicantFiles?.resumePath ? selectedApplicant.applicantFiles.resumePath : null;
  const pdfPreviewUrl = resumeUrl ? `${resumeUrl}#navpanes=0&view=FitH` : null;

  if (!selectedApplicant) return null;

  const isFirstApplicant = currentIndex === 0;
  const isLastApplicant = currentIndex === applicants.length - 1;

  return (
    <div className="md:p-8 bg-white mt-8 p-5 rounded-2xl">
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="flex-1 text-center lg:text-left">
          <div className="flex flex-col items-center mt-16">
            <div className="w-40 h-40 rounded-full overflow-hidden mb-4 bg-gray-200">
              <img src="https://via.placeholder.com/150" alt="Applicant" className="w-full h-full object-cover" />
            </div>
            <h3 className="text-2xl font-bold text-orange-500 m-0">{selectedApplicant.fullName}</h3>
            <p className="text-gray-500 text-lg m-1">Former Project Planner</p>
          </div>

          <div className="m-6 space-y-2 text-gray-700">
            <div className="flex items-center justify-center lg:justify-start">
              <h4 className="font-medium p-0 m-0">Email: </h4>
              <span className="ml-1">{selectedApplicant.email}</span>
            </div>
            <div className="flex items-center  justify-center lg:justify-start">
              <h4 className="font-medium p-0 m-0">Phone Number: </h4>
              <span className="ml-1">{selectedApplicant.contactNumber}</span>
            </div>
            <div className="flex items-center  justify-center lg:justify-start">
              <h4 className="font-medium p-0 m-0">Social Media:</h4>
              <span className="ml-1 p-o m-0">{selectedApplicant.socialMediaProfile}</span>
            </div>
            <div className="m-0 p-0 ">
              <h4 className="font-medium p-0 m-0">Introduction:</h4>
              <p className="text-gray-500 text-sm leading-relaxed mt-0 mb-6">{selectedApplicant.introductionLetter}</p>
            </div>
            <Button
              block
              size="large"
              href={resumeUrl}
              target="_blank"
              className=" mb-12 !border-orange-500 !text-orange-500 !hover:text-orange-700 !hover:border-orange-700 hover:opacity-70 font-semibold h-12 cursor-pointer"
            >
              Download CV
            </Button>
          </div>
        </div>

        <div className="flex-[1] p-0 m-0 rounded-xl shadow-inner overflow-hidden">
          {!resumeUrl && <p className="text-center text-gray-500">No resume uploaded</p>}
          {resumeUrl && <iframe src={pdfPreviewUrl} title="Applicant Resume" className="w-full h-full rounded-xl border-none" />}
        </div>
      </div>

      <div className="mt-10 flex justify-end items-center">
        <div className="flex gap-4 justify-center">
          <Button
            size="large"
            className="w-48 h-12 font-semibold !border-orange-500 !text-orange-500 hover:opacity-80 cursor-pointer"
            onClick={onPrevious}
            disabled={isFirstApplicant}
          >
            PREVIOUS
          </Button>

          <Button
            size="large"
            type="primary"
            className="w-48 h-12 font-semibold hover:opacity-80 cursor-pointer"
            style={{ backgroundColor: "#F45F0C" }}
            onClick={onNext}
            disabled={isLastApplicant}
          >
            NEXT
          </Button>
        </div>
      </div>
    </div>
  );
};

ResumeDatabaseModal.propTypes = {
  applicants: PropTypes.array.isRequired,
  currentIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
};

export default observer(ResumeDatabaseModal);
